const apiBase = "https://www.dreamchimney.com/api";
export const urlQuotesLatest = apiBase + "/quotes/latest";
export const urlQuoteByDate = apiBase + "/quotes/quote";
export const urlQuotesAll = apiBase + "/quotes/all";
export const urlQuotePost = apiBase + "/quotes/add";
export const urlQuotesComments = apiBase + "/quotes/comments";
export const urlQuotesCommentAdd = apiBase + "/quotes/comment/add";

/**
{
    quote: {
        datetime: "2021-09-28 00:00:00",
        id: "577",
        link_url: "https://www.youtube.com/watch?v=G4s_zYQ_2v4&ab_channel=JimmyKimmelLive",
        quote: "You know what i sell a lot of... cassettes",
        quoted: "Ringo Starr",
        user: "Ryan Chimney",
    }
}
*/

export const getQuoteMostRecent = (axios) => {
  return axios.get(urlQuotesLatest);
};

// 2021-02-19
export const getQuoteByDate = (axios, date) => {
  return axios.get(`${urlQuoteByDate}?date=${date}`);
};

/**
 *  30 per page
 * {
 *  quotes: [
 *  {
 *      comment_count: "0"
        date: "Sep 28, 2021"
        dateId: "2021-09-28"
        id: "577"
        link_url: "https://www.youtube.com/watch?v=G4s_zYQ_2v4&ab_channel=JimmyKimmelLive"
        quote: "You know what i sell a lot of... cassettes"
        quote_date: "2021-09-28 00:00:00"
        quoted: "Ringo Starr"
        user: "Ryan Chimney"
 *  },
 * ]
 * }
 */

export const getQuotesAll = (axios, page = 1) => {
  return axios.get(`${urlQuotesAll}?page=${page}`);
};

/**
 * 
{
  comments: [
    {
      id: "209",
      quote_id: "566",
      user: "Zeroy Chimney",
      comments: "If William Gibson was a musician, he'd have a planet wide fan base. There is a 2012 book of Gibson essays called Distrust that particular flavor. First essay? African Thumb Piano. Second essay? Rocket radio, etc. I've been reading his books since the first one, Count Zero from 1986. His last one, The Peripheral came out in 2014. Still waiting for the next . . .",
      datetime: "2019-03-05 19:20:57",
      hide: "0",
      ip: "108.192.98.175",
      date: "Mar 05, 2019"
    },
  ]
}
 */
export const getQuoteComments = (axios, id) => {
  return axios.get(`${urlQuotesComments}?id=${id}`);
};

export const postQuote = (axios, vals) => axios.post(`${urlQuotePost}`, vals);

export const addComment = (axios, vals) => axios.post(`${urlQuotesCommentAdd}`, vals);
